import React, { CSSProperties, useMemo } from "react";

import styles from "@components/layout/Right.module.scss";

export interface RightProps {
    height?: string | number;
}

const Right: React.FC<RightProps> = ({ children, height }) => {
    const style: CSSProperties = useMemo(() => {
        const _styles: CSSProperties = {};

        if (height !== undefined) {
            _styles.height = height;
        }

        return _styles;
    }, [height]);

    return (
        <div className={styles.right} style={style}>
            {children}
        </div>
    );
};

export default Right;
